import { AxiosError } from "axios";
import { useBack } from "../http";
import { AbsenceOption } from "../types/AbsenceOption";
import { ComparationAuditFilters, ComparationAuditPage } from "../types/ComparationAudit";
import { ComparationIgnore, ComparationIgnoreResult } from "../types/ComparationIgnore";
import { IgnoredDivergence } from "../types/IgnoredDivergence";
import { ComparationSync, ComparationSyncResult } from "../types/ComparationSync";
import { Events2210DTO } from "../types/Events2210DTO";
import { ExamValidation } from "../types/ExamValidation";
import { Events2220DTO } from "../types/Events2220DTO";
import { Events2240DTO } from "../types/Events2240DTO";
import { PositionDTO } from "../types/PositionDTO";
import { PositionClone, PositionCloneResult } from "../types/PositionClone";
import { RiskChangeValidation } from "../types/RiskChangeValidation";
import { SectorOption } from "../types/SectorOption";

export class ComparationService {
	constructor() {}
	axiosInstance = useBack();
	urlDefault = "/comparation";

	async getEvents2210(id: number) {
		const url =`${this.urlDefault}/${id}/2210`;
		try {
			const response = await this.axiosInstance.get<Events2210DTO>(url);
			return {...response };
		} catch (error) {
			console.log(`Não foi possível obter os eventos 2210`, error);
			return undefined;
		}
	}

	async getEvents2220(id: number) {
		const url =`${this.urlDefault}/${id}/2220`;
		try {
			const response = await this.axiosInstance.get<Events2220DTO>(url);
			return {...response };
		} catch (error) {
			console.log(`Não foi possível obter os eventos 2220`, error);
			return undefined;
		}
	}

	async getPositions(id: number, sectorId: number, cnpj?: string) {
		const company = cnpj ? `&cnpj=${encodeURIComponent(cnpj)}` : '';
		const url = `${this.urlDefault}/${id}/positions?sectorId=${sectorId}${company}`;
		try {
			const response = await this.axiosInstance.get<PositionDTO[]>(url);
			return {...response };
		} catch (error) {
			console.log(`Não foi possível obter os cargos do SGG`, error);
			return undefined;
		}
	}

	async getSectorOptions(id: number, cnpj: string) {
		const url = `${this.urlDefault}/${id}/sectors`;
		try {
			const response = await this.axiosInstance.get<SectorOption[]>(url, { params: { cnpj: cnpj } });
			return {...response };
		} catch (error) {
			console.log(`Não foi possível obter os setores do SGG`, error);
			return undefined;
		}
	}

	async createPosition(id: number, clone: PositionClone) {
		const url = `${this.urlDefault}/${id}/positions`;
		try {
			const response = await this.axiosInstance.post<PositionCloneResult>(url, clone);
			return {...response };
		} catch (error) {
			console.log(`Não foi possível criar o cargo no SGG`, error);
			const response = (error as AxiosError<PositionCloneResult>).response;
			return response ? {...response} : undefined;
		}
	}

	async getAbsences(id: number) {
		const url = `${this.urlDefault}/${id}/absences`;
		try {
			const response = await this.axiosInstance.get<AbsenceOption[]>(url);
			return {...response };
		} catch (error) {
			console.log(`Não foi possível obter os afastamentos do SGG`, error);
			return undefined;
		}
	}

	async getDismissalExamValidation(id: number) {
		const url = `${this.urlDefault}/${id}/exam-check`;
		try {
			const response = await this.axiosInstance.get<ExamValidation>(url);
			return {...response };
		} catch (error) {
			console.log(`Não foi possível validar o exame ocupacional do funcionário`, error);
			return undefined;
		}
	}

	async getRiskChangeValidation(id: number, positionId: number, sectorId?: number) {
		const url = `${this.urlDefault}/${id}/risk-change`;
		try {
			const response = await this.axiosInstance.get<RiskChangeValidation>(url, {
				params: { positionId: positionId, sectorId: sectorId }
			});
			return {...response };
		} catch (error) {
			console.log(`Não foi possível validar a mudança de riscos do cargo`, error);
			return undefined;
		}
	}

	async sync(id: number, sync: ComparationSync) {
		const url = `${this.urlDefault}/${id}/sync`;
		try {
			const response = await this.axiosInstance.post<ComparationSyncResult>(url, sync);
			return {...response };
		} catch (error) {
			console.log(`Não foi possível enviar as atualizações da comparação`, error);
			const response = (error as AxiosError<ComparationSyncResult>).response;
			return response ? {...response} : undefined;
		}
	}

	async ignore(id: number, ignore: ComparationIgnore) {
		const url = `${this.urlDefault}/${id}/ignore`;
		try {
			const response = await this.axiosInstance.post<ComparationIgnoreResult>(url, ignore);
			return {...response };
		} catch (error) {
			console.log(`Não foi possível ignorar as divergências da comparação`, error);
			const response = (error as AxiosError<ComparationIgnoreResult>).response;
			return response ? {...response} : undefined;
		}
	}

	async getAudits(filters: ComparationAuditFilters) {
		const url = `${this.urlDefault}/audits`;
		try {
			const response = await this.axiosInstance.get<ComparationAuditPage>(url, { params: filters });
			return {...response };
		} catch (error) {
			console.log(`Não foi possível obter os registros de auditoria das atualizações`, error);
			return undefined;
		}
	}

	async getIgnoredDivergences(executionId: number) {
		const url = `${this.urlDefault}/ignored`;
		try {
			const response = await this.axiosInstance
				.get<IgnoredDivergence[]>(url, { params: { executionId: executionId } });
			return {...response };
		} catch (error) {
			console.log(`Não foi possível obter as divergências ignoradas`, error);
			return undefined;
		}
	}

	async deleteIgnoredDivergence(id: number) {
		const url = `${this.urlDefault}/ignored/${id}`;
		return this.axiosInstance.delete(url);
	}

	async getEvents2240(id: number) {
		const url =`${this.urlDefault}/${id}/2240`;
		try {
			const response = await this.axiosInstance.get<Events2240DTO>(url);
			return {...response };
		} catch (error) {
			console.log(`Não foi possível obter os eventos 2240`, error);
			return undefined;
		}
	}
}